import { nowIst, todayKeyIst } from "../../utils/formatters";
import AttendanceDayCell from "./AttendanceDayCell";

/**
 * A 42-cell month grid of attendance day entries for one person (admin
 * per-staff view + the employee's own page). `days` is the API list keyed by
 * work_date; `month` is "YYYY-MM". Cells outside the month render muted.
 */
export default function AttendanceMonthCalendar({ month, days = [], onDayClick }) {
  const byDate = new Map(days.map((d) => [d.work_date, d]));
  const start = nowIst().year(Number(month.slice(0, 4))).month(Number(month.slice(5, 7)) - 1).startOf("month");
  const firstCell = start.subtract(start.day(), "day"); // back to Sunday
  const todayKey = todayKeyIst();

  const cells = [];
  for (let i = 0; i < 42; i++) {
    const date = firstCell.add(i, "day");
    const key = date.format("YYYY-MM-DD");
    cells.push({
      key,
      muted: !date.isSame(start, "month"),
      day: byDate.get(key) || (date.isSame(start, "month") ? { work_date: key, status: null } : null),
    });
  }

  return (
    <div className="cal-grid">
      {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
        <div key={d} className="cal-head">{d}</div>
      ))}
      {cells.map((c) =>
        c.muted ? (
          <div key={c.key} className="cal-cell muted" style={{ minHeight: 74 }} />
        ) : (
          <AttendanceDayCell
            key={c.key}
            day={c.day}
            today={c.key === todayKey}
            onClick={onDayClick && c.day?.status !== undefined ? () => onDayClick(c.day) : undefined}
          />
        ),
      )}
    </div>
  );
}
